import { LionMark } from "@/components/LionMark";

export function AdminLogin({ password, onPasswordChange, onSubmit }) {
  return (
    <div className="min-h-screen flex items-center justify-center px-6" data-testid="admin-login">
      <form onSubmit={onSubmit} className="w-full max-w-sm border border-[hsl(var(--lh-bone))]/15 bg-[hsl(var(--lh-ink-2))] p-8">
        <LionMark size={52} className="mb-6" />
        <h1 className="font-display text-3xl mb-2">Admin</h1>
        <p className="text-[hsl(var(--lh-bone))]/60 mb-8 text-sm">Enter the admin password to view form submissions.</p>
        <label className="lh-label">Password</label>
        <input
          type="password"
          className="lh-input mb-8"
          value={password}
          onChange={(e) => onPasswordChange(e.target.value)}
          data-testid="admin-password"
        />
        <button className="lh-btn-primary w-full justify-center" type="submit" data-testid="admin-login-btn">
          Sign in
        </button>
      </form>
    </div>
  );
}
